import { memo } from "react";

import BaseNumericInput from "./BaseNumericInput";

function PercentageInput(props) {
  return (
    <BaseNumericInput
      {...props}
      suffix="%"
      inputMode="decimal"
      formatter={(value) => {
        if (
          value === "" ||
          value === null ||
          value === undefined
        ) {
          return "";
        }

        return Number(value).toFixed(2);
      }}
      parser={(value) => {
        if (value === "") return "";

        return Number(
          String(value).replace(/%/g, "")
        );
      }}
    />
  );
}

export default memo(PercentageInput);